export default function reducer(state = {
    strCounts: [0, 0, 1, 1, 1],
    max_cost: 0,
    tours: [],
    update: false,
    toursArray: false
}, action) {
    switch (action.type) {
        case "STORE_MALDIVE_TOUR_FILTERS": {
            return {
                ...state,
                max_cost: action.list.max_cost,
                update: true
            }
        }
        case "STORE_MALDIVE_TOUR_DETAILS_UPDATE": {
            return {
                ...state,
                update: action.bool
            }
        }
        case "STORE_MALDIVE_TOUR_LISTS": {
            return {
                ...state,
                tours: action.list.tours
            }
        }
        case "CLEAR_MALDIVE_TOUR_LISTS": {
            return {
                ...state,
                tours: []
            }
        }
        case "UPDATE_MALDIVE_TOUR_LIST_ARRAY": {
            return {
                ...state,
                toursArray: action.bool
            }
        }
        case "UPDATE_MALDIVE_MORE_TOUR_LISTS": {
            return {
                ...state,
                tours: [
                    ...state.tours,
                    ...action.list.tours
                ]
            }
        }
        default:
            break;
    }
    return state
}